/* eslint-disable @typescript-eslint/no-explicit-any */
import { RowData } from '@tanstack/react-table';
import { ColumnDef } from '../../components/atoms/Table/tableFeatures';
import { TypedColumn } from '../../types/TypedColumn';

const checkMatchByLowercase = (first: string, second: string) => {
    return first.toString().toLowerCase() === second.toLowerCase();
};

const getHeaderColumns = <T extends RowData>(columns: string[], allHeaders: ColumnDef<T>[]) => {
    return columns.map(x =>
        allHeaders.find(y => checkMatchByLowercase(y.header as string, x))
    ) as TypedColumn<any>[];
};

export { getHeaderColumns, checkMatchByLowercase };
